import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import { Form } from 'antd';
import Widget from '../../Helpers/Widget';

const StaffProvider = (props) => {
  const api = new API();
  const [staffList, setStaffList] = useState([]);
  const [staffDropdownList, setStaffDropdownList] = useState([]);
  const [staffListTableFilter, setStaffListTableFilter] = useState({
    name: '',
    _id: null,
    page: 1,
    limit: 20
  });
  const [staffListLoader, setStaffListLoader] = useState(false);
  const [staffDropdownLoader, setStaffDropdownLoader] = useState(false);
  const [formAddStaffSettings] = Form.useForm();
  const [formEditStaffSettings] = Form.useForm();
  const [addStaffFromLoader, setAddStaffFromLoader] = useState(false);
  const [addStaffSingleLoader, setAddStaffSingleLoader] = useState(false);
  const [addStaffSingleData, setAddStaffSingleData] = useState({});
  const [updateStaffFromLoader, setUpdateStaffFromLoader] = useState(false);
  const [deleteStaffFromLoader, setDeleteStaffFromLoader] = useState(false);
  const [addStaffPopup, setAddStaffPopup] = useState(false);
  const [editStaffPopup, setEditStaffPopup] = useState(false);
  const fetchStaffSettings = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      setStaffListLoader(true);
    (await api.getAll("staff", { ...staffListTableFilter }, (err, res) => {
      if (res) {
        setStaffList(res?.data?.data);
        setStaffListLoader(false);
      } else {
        setStaffList([]);
        setStaffListLoader(false);
      }
    }));
  };

  const fetchStaffDropDown = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setStaffDropdownLoader(true);
    (await api.getAll("accesssettings/dropdown", {}, (err, res) => {
      if (res) {
        setStaffDropdownList(res?.data?.data);
        setStaffDropdownLoader(false);
      } else {
        setStaffDropdownList([]);
        setStaffDropdownLoader(false);
      }
    }));
  };

  const fetchStaffSettingsSingle = async (id) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setAddStaffSingleLoader(true);
    (await api.getSingle("staff/single", id, (err, res) => {
      if (res) {
        setAddStaffSingleData(res?.data?.data);
        if(res?.data?.data) {
          formEditStaffSettings.setFieldsValue({
            ...res?.data?.data,
            password:"",
            status: res?.data?.data?.status === 1 ? true : false,
            is_blocked : res?.data?.data?.is_blocked === 1 ? true : false
          });
        }
        setAddStaffSingleLoader(false);
      } else {
        setAddStaffSingleData({});
        setAddStaffSingleLoader(false);
      }
    }));
  };


const addStaffSettingsFormFetch = async (data) => {
  localStorage.getItem("rxdx_admin_login") === "true" &&
    setAddStaffFromLoader(true);
  (await api.create("staff", {
    ...data,
    status: data.status ? 1 : 0
  }, (err, res) => {
    
    if (res) {
      formAddStaffSettings.resetFields();
      setAddStaffPopup(false);
      fetchStaffSettings();
      setAddStaffFromLoader(false);
    } else {
      Widget.showMessage("error", err?.response?.data?.message||"Something went wrong");
      setAddStaffFromLoader(false);
    }
  }));
};

const updateStaffSettingsFormFetch = async (data) => {
  localStorage.getItem("rxdx_admin_login") === "true" &&
    setUpdateStaffFromLoader(true);
  (await api.update("staff/edit",addStaffSingleData?._id, {
    ...data,
    status: data.status ? 1 : 0,
    is_blocked: data.is_blocked ? 1 : 0
  }, (err, res) => {
    
    if (res) {
      setEditStaffPopup(false);
      fetchStaffSettings();
      setUpdateStaffFromLoader(false);
    } else {
      Widget.showMessage("error", err?.response?.data?.message||"Something went wrong");
      setUpdateStaffFromLoader(false);
    }
  }));
};

const deleteStaffSettings = async (id) => {
  localStorage.getItem("rxdx_admin_login") === "true" &&
  setDeleteStaffFromLoader(true);
  (await api.remove("staff", id, (err, res) => {
    if (res) {
      fetchStaffSettings();
      setDeleteStaffFromLoader(false);
    } else {
      Widget.showMessage("error", err?.response?.data?.message||"Something went wrong");
      setDeleteStaffFromLoader(false);
    }
  }));
};


  return (
    <Context.Provider value={{
      ...props,
      staffList, setStaffList,
      staffListTableFilter, setStaffListTableFilter,
      staffListLoader, setStaffListLoader,
      fetchStaffSettings,
      formAddStaffSettings,
      addStaffSettingsFormFetch,
      addStaffFromLoader, setAddStaffFromLoader,
      fetchStaffSettingsSingle,
      addStaffSingleLoader, setAddStaffSingleLoader,
      addStaffSingleData, setAddStaffSingleData,
      formEditStaffSettings,
      updateStaffFromLoader, setUpdateStaffFromLoader,
      updateStaffSettingsFormFetch,
      updateStaffFromLoader, setUpdateStaffFromLoader,
      deleteStaffFromLoader, setDeleteStaffFromLoader,
      deleteStaffSettings,
      addStaffPopup, setAddStaffPopup,
      editStaffPopup, setEditStaffPopup,
      staffDropdownList, setStaffDropdownList,
      staffDropdownLoader, setStaffDropdownLoader,
      fetchStaffDropDown
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default StaffProvider;
